import HullCleaningTab from "../../hull-cleaning/pages/HullCleaningTab";
import Header from "../../shared/app-shell/Header";
import Sidebar from "../../shared/app-shell/Sidebar";
import { themeAtom } from "../../shared/atoms";
import { logV } from "../../shared/services/debug-logger";
import { Tabs, Tab } from "../components/VesselTabs";
import BalticQuestionnaireTab from "./BalticQuestionnaireTab";
import CrewOnBoardTab from "./CrewOnBoardTab";
import OwnerTab from "./OwnerTab";
import { PerformanceTab } from "./PerformanceTab";
import PreviousCargoTab from "./PreviousCargoTab";
import TechnicalInformationTab from "./TechnicalInformationTab";
import VehicleGeneralInformationTab from "./VehicleGeneralInformationTab";
import { useAtomValue } from "jotai";
import { useParams, useSearchParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const VesselDetailsPage = () => {
  const theme = useAtomValue(themeAtom);
  const { imoNumber, requestId } = useParams();
  const [searchParams] = useSearchParams();
  const tabQuery = searchParams.get("tab");

  const initialActiveTab = requestId
    ? "Hull Cleaning"
    : tabQuery === "hull-cleaning"
      ? "Hull Cleaning"
      : tabQuery === "owner"
        ? "Owner"
        : tabQuery === "technical-information"
          ? "Technical information"
          : tabQuery === "performance-and-efficiency"
            ? "Performance and Efficiency"
            : tabQuery === "previous-cargos"
              ? "Previous cargos"
              : tabQuery === "baltic-questionnaire"
                ? "Baltic Questionnaire"
                : tabQuery === "crew-on-board"
                  ? "Crew on board"
                  : tabQuery === "vessel-general-information"
                    ? "Vessel general information"
                    : undefined;

  logV("VesselDetailsPage - BUILD", { imoNumber, tab: initialActiveTab });

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className={twMerge("flex flex-1 flex-col overflow-y-hidden px-4", theme.home.tailwind.backgound)}>
        <Header />
        <div className={twMerge("mt-8 flex w-full flex-1 flex-col overflow-hidden", theme.home.tailwind.backgound)}>
          <Tabs initialActiveTab={initialActiveTab}>
            <Tab label="Vessel general information">
              <VehicleGeneralInformationTab />
            </Tab>
            <Tab label="Technical information">
              <TechnicalInformationTab />
            </Tab>
            <Tab label="Performance and Efficiency">
              <PerformanceTab />
            </Tab>
            <Tab label="Previous cargos">
              <PreviousCargoTab />
            </Tab>
            <Tab label="Owner">
              <OwnerTab />
            </Tab>
            <Tab label="Hull Cleaning">
              <HullCleaningTab />
            </Tab>
            <Tab label="Baltic Questionnaire">
              <BalticQuestionnaireTab />
            </Tab>
            <Tab label="Crew on board">
              <CrewOnBoardTab imoNumber={imoNumber} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default VesselDetailsPage;
